/**
 * @generated SignedSource<<572880958fc9bcc18dbce34d109d6bff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSellerNotifications_seller$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "useSellerNotifications_seller";
};
export type useSellerNotifications_seller$key = {
  readonly " $data"?: useSellerNotifications_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSellerNotifications_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useSellerNotifications_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "d47f1a2d05ff83addedda668bc236f02";

export default node;
